import { themeEstra } from 'app/styles/themeEstra'
import React from 'react'
import CheckmarkIcon from 'static/icons/checkmark.svg'
import { Text } from 'app/components/ui/Text'
import styled from 'styled-components'

export const StepSuccess: React.FC = () => {
  return (
    <StepSuccessWrapper>
      <img src={CheckmarkIcon} alt='success' width='34px'></img>
      <Text variant='s16' mt={0.5} color={themeEstra.color.primari.neroEstra}>
        File Caricato
      </Text>
    </StepSuccessWrapper>
  )
}

const StepSuccessWrapper = styled.div`
  padding: 0.5rem;
`
